// extracted by mini-css-extract-plugin
export default {"imgBigWrap":"updateBanner_imgBigWrap__-UtdZ","imgWrap":"updateBanner_imgWrap__uRBpt"};